import i18n from "i18n/index";

const de = {
	title: "Sprache ändern",
	onlyReportLanguage: "Nur für Berichtssprache",
};

const en = {
	title: "Change language",
	onlyReportLanguage: "Only for report language",
};

i18n.addResourceBundle("en", "changeLanguageDialog", en);
i18n.addResourceBundle("de", "changeLanguageDialog", de);
